import { Typography } from "antd";
import React from "react";

const AccountPageHeader: React.FC = () => {
  return (
    <div className="dashboard-page-title">
      <Typography.Title level={4} style={{ margin: 0 }}>
        My Account
      </Typography.Title>
    </div>
  );
};

export default AccountPageHeader;
